import type { ConnectionInventory } from "@nlkb/api-contract/connections";

import { visiblePairedConnections } from "./connection-pairing";
import { workspaceComposePath } from "./workspace-chrome";

export const HEADER_CONNECTION_NUDGE_DISMISSED_PREFIX =
  "nlkb.header-connection-nudge-dismissed.";

export function headerConnectionNudgeStorageKey(
  organizationId: string,
  principalId: string,
): string {
  return `${HEADER_CONNECTION_NUDGE_DISMISSED_PREFIX}${organizationId}.${principalId}`;
}

export function principalHasAssignedConnection(
  connections: readonly ConnectionInventory[],
  principalId: string,
): boolean {
  return visiblePairedConnections(connections).some(
    (connection) => connection.owner_principal_id === principalId,
  );
}

export function shouldShowHeaderConnectionNudge(input: {
  readonly connections: readonly ConnectionInventory[];
  readonly principalId: string;
  readonly dismissed: boolean;
  readonly desktopRuntime: boolean;
  readonly enrolled: boolean;
  readonly viewerOnly: boolean;
}): boolean {
  if (input.dismissed) return false;
  if (input.desktopRuntime) {
    if (input.enrolled || input.viewerOnly) return false;
    return true;
  }
  return !principalHasAssignedConnection(input.connections, input.principalId);
}

export function headerConnectionNudgeLabel(desktopRuntime: boolean): string {
  return desktopRuntime ? "This computer is not syncing" : "No paired devices";
}

export function headerConnectionNudgeHref(
  organizationId: string,
  desktopRuntime: boolean,
): string {
  return desktopRuntime
    ? workspaceComposePath(organizationId, "connection")
    : `/org/${organizationId}/connections`;
}

export function readHeaderConnectionNudgeDismissed(
  organizationId: string,
  principalId: string,
): boolean {
  try {
    return (
      window.localStorage.getItem(
        headerConnectionNudgeStorageKey(organizationId, principalId),
      ) === "1"
    );
  } catch {
    return false;
  }
}

export function persistHeaderConnectionNudgeDismissed(
  organizationId: string,
  principalId: string,
): void {
  try {
    window.localStorage.setItem(
      headerConnectionNudgeStorageKey(organizationId, principalId),
      "1",
    );
  } catch {
    // Ignore quota and private-mode failures.
  }
}
